import React, { useState, useEffect, useCallback } from "react";
import { Loader, Message, Pagination} from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
// Importamos nuestro SCSS personalizado
import "./ScenesPanel.scss";

const didacticRoutesAPI = new DidacticRoutesAPI();
 
/**
 * @param {string} routeId  ID de la ruta
 * @param {string} accessToken
 * @param {Function} onEnterScene  (opcional) callback para "entrar" a la escena
 */
export function ScenesPanel({ routeId, accessToken, onEnterScene }) {
  const [scenes, setScenes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchScenes = useCallback(
    async (page) => {
      try {
        setLoading(true);
        setError(null);
        if (!routeId) return;

        // Llamada a la API para obtener escenas con paginación
        const result = await didacticRoutesAPI.getScenesByRoute(
          accessToken,
          routeId,
          page,
          4 // escenas por página
        );
        setScenes(result.scenes || []);
        setCurrentPage(result.currentPage || 1);
        setTotalPages(result.totalPages || 1);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    },
    [accessToken, routeId]
  );

  useEffect(() => {
    if (routeId) {
      fetchScenes(1);
    }
  }, [routeId, fetchScenes]);

  // Cambio de página
  const handlePageChange = (e, { activePage }) => {
    fetchScenes(activePage);
  };

  // Acción al hacer clic en "Entrar" (puede abrir en nueva pestaña o llamar a onEnterScene)
  /*const handleEnterScene = (scene) => {
    if (onEnterScene) {
      onEnterScene(scene);
    } else {
      window.open(scene.urlsala, "_blank", "noopener,noreferrer");
    }
  };*/

  // Renderizado condicional
  if (!routeId) {
    return <p>Seleccione una ruta primero.</p>;
  }

  if (loading) {
    return (
      <Loader active inline="centered">
        Cargando escenas...
      </Loader>
    );
  }

  if (error) {
    return (
      <Message negative>
        <Message.Header>Error al obtener las escenas</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  if (!scenes || scenes.length === 0) {
    return (
      <Message info>
        <Message.Header>Sin Escenas</Message.Header>
        <p>No se encontraron escenas para esta ruta.</p>
      </Message>
    );
  }

  // Función para mapear las categorías de la escena a clases SCSS
  const getCircleClass = (categoryName) => {
    // Normaliza la categoría a minúsculas
    const cat = categoryName.toLowerCase();

    if (cat.includes("humanas")) return "circle--ciencias-humanas";
    if (cat.includes("naturales")) return "circle--ciencias-naturales";
    if (cat.includes("historia")) return "circle--historia";
    if (cat.includes("matematicas")) return "circle--matematicas";
    if (cat.includes("arte")) return "circle--arte";
    if (cat.includes("vida") || cat.includes("saludable"))
      return "circle--vida-saludable";

    // Por defecto, círculo gris
    return "circle--gray";
  };

  return (
    <div className="scenes-panel ui-materials">
      {/* Contenedor tipo "grid" para las tarjetas */}
      <div className="scenes-grid">
        {scenes.map((scene) => (
          <div key={scene._id} className="e-card-scene">
            {/* Imagen principal */}
            <img
              className="card-banner"
              src={scene.bannertopUrl}
              alt={scene.title}
            />

            <div className="card-body">
              <p className="card-createdby">Creado por: Educa360</p>

              {/* Circulitos de categoría */}
              <div className="card-circles">
                {Array.isArray(scene.category) &&
                  scene.category.map((cat) => {
                    const circleClass = getCircleClass(cat);
                    return <div key={cat} className={`circle ${circleClass}`} />;
                  })}
                {Array.isArray(scene.subcategory) && (
                  <h4 className="card-subcategorie">
                    {scene.subcategory.join(", ")}
                  </h4>
                )}
              </div>

              <h3 className="card-title">{scene.title}</h3>
              <hr className="card-divider" />
              
              {/*<div className="card-actions">
                <button
                  className="btn-add-route"
                  onClick={() => handleEnterScene(scene)}
                >
                  <Icon name="sign-in" />
                  Entrar
                </button>
              </div>*/}
            </div>
          </div>
        ))}
      </div>

      {/* Barra de paginación */}
      <div className="pagination-bar">
        <Pagination
          activePage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
